<template>
  <div id="app">
    <router-view />
    <!-- 微信绑定弹窗：全局只挂载一次，供天星站与星盘页的所有支付入口在
         「未绑定微信 → 支付前预检失败」时唤起（见 utils/wechatPay.js）。 -->
    <wechat-bind-dialog />
    <!-- 悬浮客服二维码：业务页（/tianxing/* 与星盘页 /onlineChart）常驻，
         后台 /admin 与客服工作台 /cs 不显示。
         挂在 App 级（而非各页面内）→ 路由切换不重新挂载，
         用户的"收起成小框"状态得以跨页面保持。 -->
    <customer-service-float v-if="showCustomerServiceFloat" />
  </div>
</template>

<script>
import WechatBindDialog from './features/tianxing/components/WechatBindDialog.vue'
import CustomerServiceFloat from './features/tianxing/components/CustomerServiceFloat.vue'

// 悬浮客服的显示范围：仅业务页（天星站各页 + 星盘页）
const CUSTOMER_SERVICE_ROUTE_PREFIXES = ['/tianxing', '/onlineChart']

export default {
  name: 'App',
  components: {
    WechatBindDialog,
    CustomerServiceFloat
  },
  computed: {
    /** 当前路由是否属于业务页（据此决定是否渲染悬浮客服） */
    showCustomerServiceFloat () {
      const path = (this.$route && this.$route.path) || ''
      return CUSTOMER_SERVICE_ROUTE_PREFIXES.some(prefix => path.startsWith(prefix))
    }
  }
}
</script>

<style>
  /* 仅保留星盘页与天星页共用的宿主级规则（高度链 + 基础盒模型）。
     星盘专属的 padding / 字体表现放在 global.css 中限定于 #AstrolabeView；
     天星专属的字体与文字色放在 .tianxing-page 作用域内，二者互不干扰。 */
  html, body {
    height: 100%;
    margin: 0;
    padding: 0;
  }
  * {
    box-sizing: border-box;
  }
  #app {
    height: 100%;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
</style>
